module.exports = __webpack_public_path__ + "img/icon_emitter.7876bf98.gif";